<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="900px"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span v-if="onlyView">Thông tin chi tiết</span>
        <span v-else-if="item.id">Cập nhật dữ liệu</span>
        <span v-else>Tạo câu hỏi</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div v-if="errors_exist" class="row">
            <div class="col">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </div>
          </div>
          <v-row>
            <v-col cols="12" v-if="Permissioned">
              <v-switch
                v-model="item.visible"
                :label="`Trạng thái: ${item.visible ? 'Hiển thị' : 'Ẩn'}`"
                @change="setVisible(item)"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="item.un_name"
                label="Họ tên"
                class="require"
                outlined
                dense
                hide-details
                autofocus
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="item.un_phone"
                label="Số điện thoại"
                class="require"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="item.un_address"
                label="Địa chỉ"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="item.un_email"
                label="Email"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-divider/>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="branchSelected"
                :items="branchs"
                item-text="name"
                item-value="id"
                label="Lĩnh vực"
                class="require"
                outlined
                dense
                hide-details
                return-object
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.tieude"
                label="Tiêu đề"
                class="require"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <label class="require">Nội dung</label>
              <quill-editor 
                v-model="item.noidung"
                :options="editorOption"
                style="min-height:250px;"
              >
              </quill-editor>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <template v-if="!onlyView">
          <small><span class="pink--text">(*)</span> bắt buộc nhập</small>
          <v-spacer/>
          <v-btn
            color="pink darken-1"
            text
            @click="close"
          >
            Thôi
          </v-btn>
          <v-btn
            color="primary darken-1"
            text
            @click="save(item)"
          >
            Gửi đi
          </v-btn>
        </template>
        <template v-else>
          <v-spacer/>
          <v-btn
            color="pink darken-1"
            text
            @click="close"
          >
            Hủy bỏ
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { mapGetters, mapActions, mapState } from 'vuex';
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      expertId: {
        type: Number
      },
      item: {
        type: Object
      },
      onlyView: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        loading: false,
        dialog: false,
        errors_exist: false,
        errors: [],
        branchs: [],
        branchSelected: null,
        user:null,
        qasVisible: true,
        editorOption: {
          placeholder: 'Nhập văn bản ở đây',
        }
      }
    },
    computed: {
      ...mapGetters([
        'isLogged'
      ]),
      ...mapState([
        'authMod'
      ]),
      Permissioned(){
        if(!this.isLogged){
          return false;
        }
        return this.$role('so-nong-nghiep')
          || this.$role('chuyen-gia')
          || this.$role('supper-admin');
      }
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist=false;
        if (this.showDialog) {
          this.dialog = true; 
          this.getBranchs();
          if(this.item.visible == '0'){
            this.item.visible = false;
          }
          if(this.isLogged){
            this.user = this.authMod.user.user;
            this.item.un_name = this.user.name;
            this.item.un_phone = this.user.info.so_dien_thoai;
            this.item.un_address = this.user.info.dia_chi;
            this.item.un_email = this.user.email;
          }
        }
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      getBranchs () {
        const app = this;
        let url = `api/v1/branchs`;
        if(app.expertId){
          url = `api/v1/public/branchs-by-expert/${app.expertId}`;
        }
        axios.get(url)
          .then(response => {
            app.branchs = response.data;
            if(app.item.linhvuc_id) {
              app.branchSelected = app.branchs.find(
                element => element.id == app.item.linhvuc_id
              );
            } else {
              app.branchSelected = app.branchs[0];
            }
          })
          .catch(function (error) {
            app.openSnackbar({ 
              type: 'error',
              body: 'Lấy lĩnh vực không thành công!'
            });
          });
      },
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      save(item) {
        const app = this;
        let method = "post";
        let url = `api/v1/public/supports`;
        let data = item;

        if(app.branchSelected){
          data.linhvuc_id = app.branchSelected.id;
        }

        if(app.user && !data.user_id){
          data.user_id=app.user.id;
        }

        if(app.expertId){
          data.chuyengia_id=app.expertId;
        }
        
        if (data.id) {
          method = "patch";
          url = `api/v1/supports/${data.id}`;
        }

        app.loading=true;
        
        axios[method](url, data)
          .then((response) => {
            if (response.data && response.data.id) {
              app.$emit('confirmed', response.data);
            }
            app.loading=false;
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.loading=false;
            app.openSnackbar({ type: 'error' });
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      },
      setVisible(item){
        const app = this;
        app.loading=true;
        axios.patch(`api/v1/supports/${app.item.id}`, app.item)
          .then((response) => {
            app.loading=false;
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.loading=false;
            app.openSnackbar({ type: 'error' });
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      }
    }
  }
</script>